import { render, staticRenderFns } from "./XList.vue?vue&type=template&id=27995dc1&scoped=true"
import script from "./XList.vue?vue&type=script&lang=js"
export * from "./XList.vue?vue&type=script&lang=js"
import style0 from "./XList.vue?vue&type=style&index=0&id=27995dc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27995dc1",
  null
  
)

export default component.exports